/* Static noise pattern: 128x128 repeating PNG data URI.
   feTurbulence SVG filters recalculate every frame and crush GPU on mobile.
   This uses a tiny pre-baked noise tile (128x128, 1-bit alpha noise)
   that the compositor handles as a cheap repeating texture. */
const NOISE_TILE =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACABAMAAAAxEHz4AAAAGFBMVEUAAAA5OTkAAABMTExERERmZmYzMzMyMjJec5MzAAAACHRSTlMAMwAzzMz//wAW6LkEAAAAAWJLR0QAiAUdSAAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAB5JREFUaN7twTEBAGAEBBDQ//8U+0tJRUlARBRN03TjBgc6A7l3Iy0YAAAAAElFTkSuQmCC";

export default function NoiseOverlay() {
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundImage: `url("${NOISE_TILE}")`,
        backgroundRepeat: "repeat",
        pointerEvents: "none",
        zIndex: 1000,
        opacity: 0.08,
      }}
      aria-hidden="true"
    />
  );
}
